import React, { useState, useEffect } from "react";
import { useAdminApi } from "../../AdminApiContext";

const ServiceForm = ({ initial, onClose }) => {
  const { createService, updateService } = useAdminApi();

  const blank = {
    name: "",
    technical_name: "",
    daily_price: "",
    month_price: "",
    value: "",
    description: "",
    show_in_price: false,
  };

  const [form, setForm] = useState(blank);

  useEffect(() => {
    if (initial) {
      setForm({
        id: initial.id,
        name: initial.name || "",
        technical_name: initial.technical_name || "",
        daily_price: initial.daily_price ?? 0,
        month_price: initial.month_price ?? 0,
        value: initial.value ?? 0,
        description: initial.description || "",
        show_in_price: initial.show_in_price ?? false,
      });
    } else {
      setForm(blank);
    }
  }, [initial]);

const change = (e) => {
  const { name, value, type } = e.target;
  const val =
    type === "number"
      ? parseFloat(value)
      : name === "show_in_price"
      ? value === "true"
      : value;
  setForm((prev) => ({
    ...prev,
    [name]: val,
  }));
};


const save = async () => {
  const payload = { ...form };
  if (initial?.id) {
    payload.id = initial.id;  // ✅ добавляем id в тело запроса
    await updateService(initial.id, payload);
  } else {
    await createService(payload);
  }
  onClose();
};
  return (
    <div style={{ border: "1px solid #ccc", padding: 16, marginTop: 12 }}>
      <h3>{initial ? "Редактировать сервис" : "Создать сервис"}</h3>

      <input
        name="name"
        placeholder="Название"
        value={form.name}
        onChange={change}
      />
      <input
        name="technical_name"
        placeholder="Technical Name"
        value={form.technical_name}
        onChange={change}
      />
      <input
        name="daily_price"
        type="number"
        placeholder="Цена в день"
        value={form.daily_price}
        onChange={change}
      />
      <input
        name="month_price"
        type="number"
        placeholder="Цена в месяц"
        value={form.month_price}
        onChange={change}
      />
      <input
        name="value"
        type="number"
        placeholder="Значение / Объём"
        value={form.value}
        onChange={change}
      />
      <textarea
        name="description"
        placeholder="Описание"
        value={form.description}
        onChange={change}
      />

      

      <div style={{ marginTop: 8 }}>
        <label>
          Показывать при выборе тарифа:
          <select
            name="show_in_price"
            value={form.show_in_price}
            onChange={change}
            style={{ marginLeft: 8 }}
          >
            <option value={true}>Да</option>
            <option value={false}>Нет</option>
          </select>
        </label>
      </div>

      <div style={{ marginTop: 12 }}>
        <button onClick={save}>
          {initial ? "Сохранить" : "Создать"}
        </button>
        <button onClick={onClose} style={{ marginLeft: 8 }}>
          Отмена
        </button>
      </div>
    </div>
  );
};

export default ServiceForm;
